import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { DetalleBultosSkim } from "./components/DetalleBultosSkim";

class BultosSkim extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Producción Sólidos"
                    subtitulo="Bultos skim"
                    noBorder
                >
                    <DetalleBultosSkim regresar={this.regresar} />
                </Card>
            </div>
        );
    }
}

export default BultosSkim;
